<template>
    <div :class="{ 'quiz-thumbnail': true, 'animated zoomIn': !isAlready }">
        <div :class="[{ 'quiz-item block relative overflow-hidden': true, 'edit-mode': isEditQuiz }]">
            <div
                @click="!isPlus && isSchool ? onShowPreview() : onShowOverlay()"
                :class="[
                    {
                        'block relative overflow-hidden bg-cover bg-center bg-norepeat thumbnail cursor-pointer': true,
                        'quiz-disabled': quizStatus === false || quiz.suspended
                    }
                ]"
                ref="thumbnail"
            >
                <div
                    :style="{ 'background-image': `url(${imagePath})` }"
                    :class="{
                        'relative w-full h-full overflow-hidden bg-cover bg-center bg-norepeat': true,
                        'blur-suspended': quiz.suspended
                    }"
                ></div>
                <div class="absolute title text-center">
                    <h4
                        v-html="title"
                        class="text-white system-text-shadow my-0 text-xs sm:text-sm md:text-lg uppercase font-opensans w-full"
                    ></h4>
                </div>

                <div class="badge-box absolute">
                    <div
                        v-if="quizStatus === false || quiz.suspended"
                        v-tippy="{
                            placement: 'top',
                            content: $t('quiz_thumbnail_suspended_tooltip'),
                            onShow: () => quiz.suspended == true
                        }"
                        class="inactive-badge shadow-text-none"
                    >
                        {{
                            quiz.suspended ? $t('quiz_thumbnail_suspended_badge') : $t('quiz_thumbnail_inactive_badge')
                        }}
                    </div>

                    <div
                        v-if="isTeacher && quiz.show_school_list"
                        v-tippy="{
                            placement: 'top',
                            content: $t('quiz_share_school_list_tooltip')
                        }"
                        class="share-badge"
                    >
                        <i class="fas fa-school text-xs"></i>
                    </div>
                    <div
                        v-if="isTeacher && quiz.show_school_country_list"
                        v-tippy="{
                            placement: 'top',
                            content: $t('quiz_share_school_country_list_tooltip')
                        }"
                        class="share-badge"
                    >
                        <i class="fas fa-flag text-xs"></i>
                    </div>
                    <div
                        v-if="isSchool && quiz.user_id && quiz.school_id"
                        v-tippy="{
                            placement: 'top',
                            content: $t('quiz_was_created_by_teacher')
                        }"
                        class="share-badge"
                    >
                        <i class="fas fa-graduation-cap text-xs"></i>
                    </div>
                </div>

                <!-- <div v-if="!isCompetitions && !isSchool" class="absolute share-button font-size-27 lg:font-size-30">
                    <div
                        v-if="!isShare"
                        @click="onClickShareButtonHandler"
                        :content="$t('quiz_thumbnail_popup_share')"
                        v-tippy
                    >
                        <i class="fas fa-share-alt-square system-text-color"></i>
                    </div>
                </div> -->
                <div v-if="quiz.ribbon_message" class="ribbon-box">
                    <div class="ribbon">
                        <div class="ribbon-name shadow-text-none">
                            {{ quiz.ribbon_message ? quiz.ribbon_message : '' }}
                        </div>
                        <div class="ribbon-tail"></div>
                    </div>
                </div>
            </div>
            <div
                v-if="isCompetitions"
                class="sponsor-active-box text-center text-xs sm:text-sm md:text-lg font-opensans w-full pb-1 relative"
            >
                {{
                    quiz.is_sponsor_quiz
                        ? $t('quiz_thumbnail_competitions_status_active')
                        : $t('quiz_thumbnail_competitions_status_completed')
                }}
            </div>
            <div v-if="isShowOptions" class="quiz-options flex w-full overflow-hidden relative">
                <div v-if="isEditQuiz" class="edit-quiz-options flex w-full h-full">
                    <div
                        v-if="id != 'mock' && !quiz.suspended"
                        v-tippy="{ placement: 'top' }"
                        :content="$t('quiz_thumbnail_toggle_status')"
                        class="quiz-option-btn-box flex-1 flex justify-center px-4 cursor-pointer"
                    >
                        <XToggleSwitch
                            @input="toggleQuizStatus()"
                            :checked="quizStatus"
                            :show-background="true"
                            :show-toggle-symbol="true"
                            height="20"
                            border-color="#fff"
                            checked-color="#e43146"
                        />
                    </div>
                    <XButton
                        v-if="id != 'mock' && !quiz.suspended && isRoleCanCopy"
                        v-tippy="{ placement: 'top' }"
                        @click="onCopyToMyQuiz(quiz)"
                        :content="$t('quiz_thumbnail_duplicate_quiz')"
                        bg-color="transparent"
                        color="#fff"
                        class="flex-1 p-0 shadow-text-none"
                        aria-label="Duplicate quiz"
                    >
                        <i class="far fa-clone"></i>
                    </XButton>
                    <XButton
                        v-tippy="{ placement: 'top' }"
                        @click="onClickDeleteButtonHandler()"
                        :content="$t('quiz_thumbnail_delete_my_quiz')"
                        :disabled="id == 'mock'"
                        bg-color="transparent"
                        color="#fff"
                        class="flex-1 shadow-text-none"
                        aria-label="Delete quiz"
                    >
                        <i class="far fa-trash-alt font-size-20"></i>
                    </XButton>
                </div>
                <div
                    v-else
                    :class="{ 'share-play-options flex w-full h-full': true, 'blur-suspended': quiz.suspended }"
                >
                    <XButton
                        v-if="isCanEdit && !isSchool && quiz.approval_status !== 'approved'"
                        v-tippy="{ placement: 'top' }"
                        @click="onClickEditQuiz()"
                        :content="$t('quiz_thumbnail_edit_quiz', { type: quiz.type })"
                        :disabled="quiz.suspended"
                        bg-color="transparent"
                        color="#000"
                        class="flex-1 p-0 shadow-text-none"
                        aria-label="Edit quiz"
                        id="edit-quiz-button-box"
                    >
                        <i id="edit-quiz-button" class="fas fa-edit font-size-20"></i>
                    </XButton>

                    <XButton
                        v-if="
                            !quiz.shared_user ||
                            (quiz.shared_user && !quiz.shared_user.includes(this.userId)) ||
                            (quiz.shared_user &&
                                quiz.shared_user.includes(this.userId) &&
                                ((!quiz.share_setting.can_read && !quiz.share_setting.can_edit) ||
                                    quiz.approval_status === 'approved'))
                        "
                        v-tippy="{ placement: 'top' }"
                        @click="isSchool ? onShowPreview() : toggleThumbnail()"
                        :content="
                            quiz.type == 'quiz'
                                ? $t('quiz_thumbnail_preview')
                                : $t('quiz_thumbnail_start_live', { type: quiz.type })
                        "
                        :disabled="(quiz.type == 'poll' && quizStatus === false) || id == 'mock' || quiz.suspended"
                        bg-color="transparent"
                        color="#000"
                        class="flex-1 shadow-text-none"
                        aria-label="Preview quiz"
                        id="preview-quiz-button"
                    >
                        <i
                            v-if="(quiz.type == 'poll' && quizStatus === false) || id == 'mock' || quiz.suspended"
                            class="fas fa-eye-slash font-size-20"
                        ></i>
                        <i v-else class="fas fa-eye font-size-20"></i>
                    </XButton>

                    <XButton
                        v-if="
                            (isShare || (isSchool && !quiz.auto_generate)) &&
                            quiz.approval_status !== 'approved' &&
                            isRoleCanCopy
                        "
                        v-tippy="{ placement: 'top' }"
                        @click="onCopyToMyQuiz(quiz)"
                        :content="$t('quiz_thumbnail_copy_to_myquiz')"
                        :disabled="quizStatus === false || quiz.suspended"
                        bg-color="transparent"
                        color="#000"
                        class="flex-1 shadow-text-none"
                        aria-label="Copy quiz"
                        id="copy-to-myquiz-button"
                    >
                        <i class="fas fa-clone font-size-18"></i>
                    </XButton>

                    <XButton
                        v-if="!isSchool"
                        v-tippy="{ placement: 'top' }"
                        @click="onShowOverlay"
                        :content="$t('quiz_thumbnail_share_play_option')"
                        :disabled="quizStatus === false || quiz.suspended"
                        bg-color="transparent"
                        color="#000"
                        class="flex-1 shadow-text-none"
                        aria-label="Share quiz"
                        id="share-quiz-button"
                    >
                        <i class="fas fa-share-alt font-size-20"></i>
                    </XButton>
                </div>
            </div>

            <div class="shadow absolute pointer-events-none"></div>
        </div>

        <div ref="overlay">
            <div v-if="isShowOverlay" @click="onClickOverlay" class="overlay-animation" ref="overlayAnimation">
                <div class="overlay-container">
                    <!-- Begin Close Button -->
                    <div @click="onCloseOverlay" class="system-text-color btn-close cursor-pointer">
                        <i class="fa fa-times"></i>
                    </div>
                    <!-- End Close Button -->

                    <!-- Begin Big Thumbnail -->
                    <div class="absolute overlay-thumbnail-box w-full">
                        <div
                            :class="{ 'is-competition': isCompetitions }"
                            class="relative overflow-hidden bg-cover bg-center bg-norepeat big-thumbnail"
                            ref="bigThumbnail"
                        >
                            <div
                                :style="{ 'background-image': 'url(' + imagePath + ')', 'padding-top': '100%' }"
                                class="system-text-color no-underline relative overflow-hidden bg-cover bg-center bg-norepeat"
                            ></div>
                            <div
                                v-if="!isCompetitions && !isSchool"
                                class="absolute share-button font-size-27 lg:font-size-30"
                            ></div>
                            <div class="absolute title text-center">
                                <h4
                                    v-html="title"
                                    class="system-text-color my-0 text-xs sm:text-sm md:text-lg uppercase font-opensans w-full"
                                ></h4>
                            </div>
                            <div v-if="quiz.ribbon_message" class="ribbon-box">
                                <div class="ribbon">
                                    <div class="ribbon-name shadow-text-none">
                                        {{ quiz.ribbon_message ? quiz.ribbon_message : '' }}
                                    </div>
                                    <div class="ribbon-tail"></div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!isCompetitions && isOwnerQuiz" id="simple-state" class="text-center w-full">
                            <span>{{
                                $t('my_quiz_player_state', {
                                    live: countPlaying.play_live,
                                    alone: countPlaying.play_alone
                                })
                            }}</span>
                        </div>
                    </div>

                    <!-- End Big Thumbnail -->

                    <!-- Begin content -->
                    <div ref="overlayContent" class="overlay-content">
                        <h2
                            :class="isCompetitions ? 'mb-3' : 'mb-5'"
                            class="overlay-quiz-title system-text-color system-text-shadow mt-0 title font-size-20 md:font-size-30"
                        >
                            {{ title }}
                        </h2>
                        <div v-if="isShare" class="flex flex-col mb-2 md:mb-3">
                            <span
                                v-if="quiz.user && quiz.user.name"
                                class="overlay-shared-by system-text-color system-text-shadow font-bold mt-0 mb-1 font-size-16 md:font-size-18"
                            >
                                {{ $t('quiz_thumbnail_shared_by') }}
                                <span class="font-normal">{{ quiz.user.name }}</span>
                            </span>
                            <span
                                v-if="quiz.share_setting && quiz.share_setting.can_read && !quiz.share_setting.can_edit"
                                class="overlay-shared-by system-text-color font-size-14 md:font-size-16"
                            >
                                {{ $t('quiz_thumbnail_shared_read_only') }}
                            </span>
                            <span
                                v-if="quiz.share_setting && quiz.share_setting.can_edit"
                                class="overlay-shared-by system-text-color font-size-14 md:font-size-16"
                            >
                                {{ $t('quiz_thumbnail_shared_can_edit') }}
                            </span>
                        </div>
                        <div v-if="!isCompetitions" class="menu-list">
                            <a
                                :href="
                                    isSchool
                                        ? getNuxtUrl(`/live/master/${quiz.code}/start?type=school`)
                                        : getNuxtUrl(`/live/master/${quiz.code}/start`)
                                "
                                target="_blank"
                                class="menu-item flex items-center md:my-2 system-text-color system-text-shadow no-underline w-full xl:w-auto"
                                id="start-live"
                            >
                                <LiveIcon />
                                {{
                                    $t('quiz_thumbnail_start_live', {
                                        type: quizText.charAt(0).toUpperCase() + quizText.slice(1)
                                    })
                                }}
                            </a>
                            <a
                                :href="
                                    isSchool
                                        ? getNuxtUrl(`/live/master/${quiz.code}/start?type=school&mode=team`)
                                        : getNuxtUrl(`/live/master/${quiz.code}/start?mode=team`)
                                "
                                target="_blank"
                                class="menu-item flex items-center md:my-2 system-text-color system-text-shadow no-underline w-full xl:w-auto"
                                id="start-live-teams"
                            >
                                <LiveIcon />
                                {{
                                    $t('quiz_thumbnail_start_live_teams', {
                                        type: quizText.charAt(0).toUpperCase() + quizText.slice(1)
                                    })
                                }}
                            </a>

                            <div
                                @click="
                                    showShareModal = true
                                    isFrontPage = true
                                    removeHints()
                                "
                                class="menu-item flex items-center md:mb-2 md:mt-4 system-text-color system-text-shadow no-underline w-full xl:w-auto cursor-pointer"
                                id="start-single"
                            >
                                <i class="fas fa-play system-text-shadow"></i>
                                {{ $t('quiz_thumbnail_share_quiz', { type: quiz.type }) }}
                            </div>
                            <template v-if="!isApprove">
                                <div
                                    v-if="quiz.type && quiz.type != 'poll'"
                                    @click="
                                        showShareModal = true
                                        removeHints()
                                    "
                                    class="menu-item flex items-center md:my-2 system-text-color system-text-shadow no-underline cursor-pointer w-full xl:w-auto text-shadow"
                                    id="share-with-report"
                                >
                                    <play-report-icon></play-report-icon>
                                    {{ $t('quiz_thumbnail_normal_reports') }}
                                </div>
                                <router-link
                                    v-if="quiz.report_path"
                                    :to="{
                                        name: 'report',
                                        params: {
                                            quizId: id
                                        }
                                    }"
                                    class="menu-item flex items-center md:mb-4 md:mt-2 w-full xl:w-auto system-text-color system-text-shadow no-underline"
                                    rel="noopener"
                                >
                                    <i class="fas fa-file-alt system-text-color system-text-shadow"></i>
                                    {{ $t('quiz_thumbnail_reports') }}
                                </router-link>
                            </template>
                            <div
                                v-if="!isFromMaster && !isShare && !isApprove && !isSchoolRoles"
                                @click="openEmbedModal"
                                class="menu-item flex items-center md:my-2 w-full xl:w-auto system-text-color system-text-shadow no-underline cursor-pointer text-shadow"
                                id="embed-quiz"
                            >
                                <i class="fas fa-code system-text-shadow"></i>
                                {{ $t('quiz_thumbnail_embed_quiz', { type: quizText }) }}
                            </div>
                            <div
                                v-if="!isShare && isOwnerQuiz"
                                @click="onClickShareButtonHandler"
                                class="menu-item flex items-center md:my-2 w-full xl:w-auto system-text-color system-text-shadow no-underline cursor-pointer text-shadow"
                                id="share-with-user"
                            >
                                <i class="fas fa-share-alt system-text-color system-text-shadow"></i>
                                {{ $t('quiz_thumbnail_popup_share', { type: quiz.type }) }}
                            </div>
                            <div
                                v-if="isSchool"
                                @click="onShowPreview()"
                                class="menu-item flex items-center md:my-2 w-full xl:w-auto system-text-color system-text-shadow no-underline cursor-pointer text-shadow"
                                id="preview-quiz"
                            >
                                <i class="fas fa-eye system-text-color system-text-shadow"></i>
                                {{ $t('quiz_thumbnail_preview') }}
                            </div>

                            <!-- <div class="menu-item" v-if="!isFromMaster && !isShare && !isApprove">
                                <router-link
                                    :to="{
                                        path: `/preview/${id}`,
                                        query: {
                                            mode: isSchool ? 'preview' : undefined
                                        }
                                    }"
                                    class="system-text-color no-underline capitalize"
                                >
                                    <i class="fas fa-eye mr-2"></i>
                                    {{ $t('quiz_thumbnail_preview') }}
                                </router-link>
                            </div>
                            <div class="menu-item" :style="isApprove ? { 'margin-top': '1rem' } : ''" v-if="isApprove">
                                <a class="system-text-color no-underline capitalize cursor-pointer" @click="setPreview(id)">
                                    <i class="fas fa-eye mr-2"></i>
                                    {{ $t('quiz_thumbnail_preview') }}
                                </a>
                            </div> -->
                            <a
                                v-if="isShare"
                                @click="onRemoveShareQuiz"
                                class="menu-item flex items-center md:my-2 w-full xl:w-auto system-text-color system-text-shadow cursor-pointer"
                            >
                                <i class="fas fa-trash-alt system-text-shadow"></i>
                                {{ $t('quiz_thumbnail_remove_share_quiz', { type: quizText }) }}
                            </a>

                            <a
                                v-if="isShowSubmitForApprovalButton && !isPoll"
                                @click="onClickEditQuiz"
                                class="menu-item flex items-center md:my-2 w-full xl:w-auto system-text-color system-text-shadow cursor-pointer no-underline"
                            >
                                <i class="fas fa-th-large system-text-shadow"></i>
                                {{ $t('quiz_thumbnail_submit_approval') }}
                            </a>
                            <!-- <div class="menu-item system-text-color cursor-pointer text-shadow" v-if="typeQuiz == 'normal'">
                                <div @click="onClickDeleteButtonHandler">
                                    <i class="fas fa-trash-alt system-text-color mr-2"></i>
                                    {{ $t('quiz_thumbnail_delete_my_quiz') }}
                                </div>
                            </div> -->
                        </div>
                        <div v-if="isCompetitions" class="font-opensans overlay-competitions">
                            <div class="flex flex-col mb-2 md:mb-3">
                                <div class="items-baseline">
                                    <span
                                        class="font-bold font-size-16 md:font-size-20 system-text-color system-text-shadow mr-2"
                                    >
                                        {{ $t('quiz_thumbnail_competitions_status') }}
                                    </span>
                                    <span class="system-text-color system-text-shadow font-size-16 md:font-size-20">
                                        {{
                                            !quiz.is_sponsor_quiz
                                                ? $t('quiz_thumbnail_competitions_status_completed')
                                                : $t('quiz_thumbnail_competitions_status_active')
                                        }}
                                    </span>
                                </div>
                                <div class="system-text-color font-size-14 md:font-size-16">
                                    {{
                                        !quiz.is_sponsor_quiz
                                            ? $t('quiz_thumbnail_competitions_winner_informed')
                                            : $t('quiz_thumbnail_competitions_winner_contracted')
                                    }}
                                </div>
                            </div>
                            <div class="flex flex-col mb-2 md:mb-3">
                                <div class="items-baseline">
                                    <span
                                        class="font-bold font-size-16 md:font-size-20 system-text-color system-text-shadow mr-2"
                                    >
                                        {{ $t('quiz_thumbnail_competitions_score') }}
                                    </span>
                                    <span class="system-text-color system-text-shadow font-size-16 md:font-size-20">
                                        {{ quiz.score }}% | {{ quiz.time }} sec
                                    </span>
                                </div>
                            </div>
                            <div
                                v-if="quiz.is_sponsor_quiz && quiz.sponsor_setting.is_show_share_button"
                                class="flex flex-col mb-2 md:mb-3"
                            >
                                <div class="flex flex-col">
                                    <div
                                        class="font-bold font-size-16 md:font-size-20 system-text-color system-text-shadow lg:mr-4"
                                    >
                                        {{ $t('quiz_thumbnail_competitions_recruited_by') }}
                                    </div>
                                    <div class="system-text-color font-size-16 md:font-size-20">
                                        {{
                                            quiz.sharer_user.name
                                                ? quiz.sharer_user.name
                                                : $t('quiz_thumbnail_competitions_no_one')
                                        }}
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="quiz.is_sponsor_quiz && quiz.sponsor_setting.is_show_share_button"
                                class="flex flex-col mb-2 md:mb-3"
                            >
                                <div class="flex flex-col">
                                    <div
                                        class="font-bold font-size-16 md:font-size-20 system-text-color system-text-shadow lg:mr-4"
                                    >
                                        {{ $t('quiz_thumbnail_competitions_have_recruited') }}
                                    </div>
                                    <div class="system-text-color font-size-16 md:font-size-20">
                                        {{
                                            $t('quiz_thumbnail_competitions_players_recruited', {
                                                count: quiz.recruited_count
                                            })
                                        }}
                                    </div>

                                    <div class="mt-2 md:mt-3">
                                        <div
                                            v-if="quiz.is_sponsor_quiz && quiz.recruited_count > 0"
                                            class="system-text-color font-size-14 sm:font-size-16 mt-2 italic"
                                        >
                                            {{
                                                $t('quiz_thumbnail_competitions_extra_change', {
                                                    count: quiz.recruited_count
                                                })
                                            }}
                                        </div>
                                        <div
                                            v-if="quiz.is_sponsor_quiz"
                                            v-html="
                                                quiz.recruited_count > 0
                                                    ? $t('quiz_thumbnail_competitions_share_message')
                                                    : $t('quiz_thumbnail_competitions_share_message_no_recruit')
                                            "
                                            class="system-text-color font-size-14 md:font-size-16 italic"
                                        ></div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="quiz.is_sponsor_quiz && quiz.sponsor_setting.is_show_share_button"
                                class="system-text-color cursor-pointer font-size-16 md:font-size-20"
                            >
                                <a @click="isShareQuizModal = true" class="compet-btn system-text-shadow">
                                    {{ $t('quiz_thumbnail_competitions_your_share') }}
                                    <span class="underline">URL</span>
                                    |
                                    <span class="underline">QR</span>
                                </a>
                            </div>
                            <div class="font-size-16 md:font-size-20 mt-3">
                                <a
                                    :href="`${quiz.url}?ref=myquiz`"
                                    target="_blank"
                                    class="compet-btn mr-4 system-text-color system-text-shadow no-underline"
                                >
                                    <i class="fas fa-play mr-2 system-text-shadow"></i>
                                    {{ $t('quiz_thumbnail_competitions_start_single') }}
                                </a>
                                <a
                                    :href="getNuxtUrl(`/live/master/${quiz.code}/start`)"
                                    target="_blank"
                                    class="compet-btn system-text-color system-text-shadow no-underline"
                                >
                                    <i class="fas fa-play mr-2 system-text-shadow"></i>
                                    {{
                                        $t('quiz_thumbnail_competitions_start_live', {
                                            type: quizText.charAt(0).toUpperCase() + quizText.slice(1)
                                        })
                                    }}
                                </a>
                            </div>
                        </div>
                    </div>
                    <!-- End content -->
                    <div v-if="!isCompetitions" id="wiki-text" class="w-full">
                        <span v-html="$t('quiz_thumbnail_wiki')"></span>
                    </div>
                </div>
                <ShareQuizModal v-model="shareLinkUrl" v-if="isShareQuizModal" @close="isShareQuizModal = false" />
            </div>
            <PlayAloneShareModal
                v-if="showShareModal"
                v-model="quiz.url"
                @close="
                    showShareModal = false
                    isFrontPage = false
                    callHints()
                "
                @copied="copyLink($event, 'link')"
                @share="shareLink"
                @open-payment-popup="onOpenPaymentPopup"
                :is-front-page="isFrontPage"
                :quiz-id="quiz._id.$oid"
                :quiz-title="quiz.title"
                :title="
                    isFrontPage
                        ? this.$t('playalone_share_quiz_modal_header')
                        : this.$t('playalone_share_quiz_modal_header_save_report')
                "
            />
            <EmbedModal
                v-if="showEmbedModal"
                @close="
                    showEmbedModal = false
                    callHints()
                "
                @copied="copyLink($event, 'embed')"
                @open-payment-popup="showPaymentPopup = true"
                :quiz="quiz"
                :embed="embed"
            />
            <PaymentPopup
                v-if="showPaymentPopup"
                @close="showPaymentPopup = false"
                @success="getEmbed"
                :quiz-id="quiz._id.$oid"
                :payment-description="paymentDescription"
            />
        </div>
    </div>
</template>

<script>
import popup from '@/lib/popup.js'
import appConfig from '@/app.config.js'
import Request from '@/lib/request.js'
import { currentUser, getToken } from '@/lib/user'
import PlayReportIcon from '@/components/PlayReportIcon.vue'
import PlayAloneShareModal from '@/components/PlayAloneShareModal.vue'
import ShareQuizModal from '@/components/ShareQuizModal'
import PaymentPopup from '@/components/PaymentPopup'
import EmbedModal from '@/components/EmbedModal.vue'
import XButton from '@/components/v2/XButton'
import XToggleSwitch from '@/components/v2/XToggleSwitch'
import { load } from 'recaptcha-v3'
import helper from '@/lib/helper.js'
import LiveIcon from '@/components/LiveIcon'
import IntroHint from '@/lib/intro.js'
import introJsData from '@/mixins/introjs-data'
import helperMixins from '@/mixins/helper'
import { nuxtUrl } from '@/lib/nuxt-url.js'

export default {
    name: 'QuizThumbnail',

    components: {
        PlayReportIcon,
        PlayAloneShareModal,
        ShareQuizModal,
        EmbedModal,
        PaymentPopup,
        XButton,
        XToggleSwitch,
        LiveIcon
    },

    mixins: [introJsData, helperMixins],

    props: {
        title: {
            type: String
        },

        image: {
            type: String
        },

        id: {
            type: String
        },

        isFromMaster: {
            type: Boolean
        },

        isShare: {
            type: Boolean
        },

        isApprove: {
            type: Boolean
        },

        isCompetitions: {
            type: Boolean
        },

        isSchool: {
            type: Boolean
        },

        isEditQuiz: {
            type: Boolean,
            default: false
        },

        sharedUser: {
            type: Array
        },

        quiz: {},

        typeQuiz: {
            type: String
        }
    },

    data() {
        return {
            isShowOverlay: false,
            isAlready: false,
            showShareModal: false,
            countPlaying: [],
            isShareQuizModal: false,
            shareLinkUrl: '',
            showPaymentPopup: false,
            showEmbedModal: false,
            embed: {},
            userId: '',
            quizStatus: true,
            introHint: new IntroHint(),
            isFrontPage: false,
            paymentDescription: ''
        }
    },

    computed: {
        imagePath() {
            return this.image && this.image.length
                ? this.image
                : this.quiz.image_placeholder && this.quiz.image_placeholder.length
                ? require(`../../../public/images/${this.quiz.image_placeholder}`)
                : require('../../../public/images/no-image2.png')
        },

        isShowSubmitForApprovalButton() {
            return (
                !this.isShare &&
                (currentUser().role === 'creator' || currentUser().role === 'contributor') &&
                this.quiz.approval_status !== 'pending' &&
                this.quiz.approval_status !== 'approved'
            )
        },

        isPoll() {
            return this.quiz.type && this.quiz.type === 'poll'
        },

        quizText() {
            return this.quiz.type === 'poll' ? 'poll' : 'quiz'
        },

        isPlus() {
            return currentUser().role === 'teacher_plus' || currentUser().role === 'student_plus'
        },

        isTeacher() {
            return currentUser().role == 'teacher' || currentUser().role == 'teacher_plus'
        },

        isOwnerQuiz() {
            if (this.isSchool) {
                if (!this.quiz.user_id) {
                    return false
                }

                return this.quiz.user_id === currentUser().id
            }

            return true
        },

        isShowOptions() {
            if (!this.isCompetitions && this.isTeacherPlus && this.isSchool) {
                return true
            }
            return !this.isCompetitions && !this.isSchool
        },

        isCanEdit() {
            return (
                (!this.isFromMaster && !this.isShare && !this.isApprove && !this.isSchool) ||
                (this.isSchool && this.quiz.user_id === this.userId) ||
                (this.isApprove && this.quiz.user_id === this.userId) ||
                (this.quiz.shared_user &&
                    this.quiz.shared_user.includes(this.userId) &&
                    (this.quiz.share_setting.can_read || this.quiz.share_setting.can_edit))
            )
        },

        isRoleCanCopy() {
            return currentUser().role === 'teacher_plus' || currentUser().role === 'premium_user'
        }
    },

    watch: {
        quiz(data) {
            if (data.status == false) {
                this.quizStatus = false
            }
        },

        'quiz.status'(val) {
            this.quizStatus = val
        }
    },

    created() {
        if (this.quiz.status == false) {
            this.quizStatus = false
        }
    },

    mounted() {
        this.userId = currentUser().id

        setTimeout(() => {
            this.isAlready = true
        }, 1000)
    },

    methods: {
        onOpenPaymentPopup(val) {
            if (val == 'report') {
                this.paymentDescription = this.$t('purchase_header_upgrade_report_description')
            }

            this.showPaymentPopup = true
        },

        callHints() {
            this.introHint.register(this.hintsQuizThumbnail)
        },

        removeHints() {
            this.introHint.removeHints()
        },

        onClickEditQuiz() {
            this.$emit('open-quiz-creator', this.id)
            this.$store.commit('setCreateNewQuiz', false)
        },

        onClickShareButtonHandler() {
            this.removeHints()
            this.$emit('open-share-popup', {
                id: this.id,
                title: this.title,
                imagePath: this.imagePath,
                sharedUser: this.sharedUser
            })
        },

        onClickDeleteButtonHandler() {
            popup.confirm(this.$t('my_quiz_alert_delete_quiz'), () => {
                this.$emit('delete-my-quiz', {
                    id: this.id
                })
            })
        },

        onRemoveShareQuiz() {
            popup.confirm(this.$t('quiz_thumbnail_alert_delete_quiz'), () => {
                this.$emit('delete-share-quiz', {
                    id: this.id,
                    title: this.title,
                    imagePath: this.imagePath,
                    sharedUser: this.sharedUser
                })
            })
        },

        onShowOverlay() {
            if (this.quizStatus === false || this.quiz.suspended) return

            this.createShareLink()
            this.isShowOverlay = true

            this.$nextTick(() => {
                const thumbnail = this.$refs.thumbnail
                const overlay = this.$refs.overlay
                const overlayAnimation = this.$refs.overlayAnimation
                const overlayContent = this.$refs.overlayContent

                let thumbnailRect = {
                    width: thumbnail.getBoundingClientRect().width,
                    height: thumbnail.getBoundingClientRect().height,
                    top: thumbnail.getBoundingClientRect().top,
                    left: thumbnail.getBoundingClientRect().left
                }

                let contentRect = {
                    width: overlayContent.getBoundingClientRect().width,
                    height: overlayContent.getBoundingClientRect().height,
                    top: overlayContent.getBoundingClientRect().top,
                    left: overlayContent.getBoundingClientRect().left
                }

                overlay.style.setProperty('--big-thumbnail-w', thumbnailRect.width / 1 + 'px')
                overlay.style.setProperty('--big-thumbnail-h', thumbnailRect.height / 1 + 'px')
                overlay.style.setProperty('--big-thumbnail-top', thumbnailRect.top + 'px')
                overlay.style.setProperty('--big-thumbnail-left', thumbnailRect.left + 'px')
                overlay.style.setProperty('--overlay-bg-pos-top', thumbnailRect.top + thumbnailRect.width / 2 + 'px')
                overlay.style.setProperty('--overlay-bg-pos-left', thumbnailRect.left + thumbnailRect.height / 2 + 'px')

                if (window.innerHeight <= 414) {
                    overlay.style.setProperty('--big-thumbnail-w', thumbnailRect.width / 1.5 + 'px')
                }

                if (window.innerHeight <= 320) {
                    overlay.style.setProperty('--big-thumbnail-w', thumbnailRect.width / 2 + 'px')
                }

                this.$store
                    .dispatch('getQuizPlaying', this.quiz)
                    .then(res => {
                        this.countPlaying = res.data.data
                    })
                    .catch(() => {})

                if (this.isCompetitions) {
                    overlay.style.setProperty('--big-thumbnail-competition-top', contentRect.top + 'px')
                }

                this.$nextTick(() => {
                    setTimeout(() => {
                        overlayAnimation.classList.add('active')

                        this.removeHints()
                        setTimeout(() => {
                            this.callHints()
                        }, 1000)
                    }, 50)
                })
            })
        },

        onShowPreview() {
            this.$emit('open-quiz-preview', this.quiz.code)

            this.removeHints()
        },

        createRequest() {
            const token = getToken()

            return new Request({
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
        },

        findOrderAbility() {
            const request = this.createRequest()

            return new Promise((resolve, reject) => {
                request
                    .get(appConfig.api.findOrderAbility)
                    .then(res => resolve(res.data.data))
                    .catch(err => reject(err))
            })
        },

        async onToggleNormalReport() {
            const ability = await this.findOrderAbility()

            if (!ability.is_24hrs_access && !ability.has_subscribed) {
                this.showPaymentPopup = true
            } else {
                this.showShareModal = true
            }
        },

        createShareLink() {
            this.$store
                .dispatch('createSponsorQuizShareLink', {
                    quiz_id: this.id
                })
                .then(res => {
                    this.shareLinkUrl = res.data.data.url
                })
        },

        onCloseOverlay() {
            const overlayAnimation = this.$refs.overlayAnimation
            const simpleState = document.querySelector('#simple-state')
            const wikiText = document.querySelector('#wiki-text')
            let currentUrl = window.location.pathname

            const urlParams = new URL(window.location.href)
            if (urlParams.searchParams.has('type')) {
                currentUrl = window.location.href
            }

            if (urlParams.searchParams.has('quiz-oid')) {
                urlParams.searchParams.delete('quiz-oid')
                currentUrl = urlParams.toString()
            }

            window.history.replaceState({}, '', currentUrl)

            overlayAnimation.classList.add('hide')

            if (simpleState) {
                simpleState.classList.add('hide')
            }

            if (wikiText) {
                wikiText.classList.add('hide')
            }

            this.retry(() => {
                this.removeHints()
            }, 10)

            setTimeout(() => {
                overlayAnimation.classList.add('alreadyHide')
            }, 600)

            setTimeout(() => {
                this.isShowOverlay = false
            }, 700)
        },

        onClickOverlay(e) {
            if (e.target.classList.toString().indexOf('overlay-animation') > -1) {
                this.onCloseOverlay()
            }
        },

        setPreview(quizId) {
            this.$store.dispatch('fetchQuestionById', quizId).then(res => {
                if (res.data.status_code == 200) {
                    this.$router.push({ name: 'preview' })
                }
            })
        },

        getQuizDataById(quiz) {
            this.title = quiz.title
            this.image = quiz.image
            this.isFromMaster = quiz.isFromMaster
            this.isShare = false
            this.isApprove = false
            this.sharedUser = quiz.shared_user
            this.quiz = quiz
            this.$nextTick(() => {
                this.onShowOverlay()
            })
        },

        shareLink(url) {
            navigator.share({
                title: this.title,
                text: `Play ${this.title}`,
                url: url
            })
        },

        copyLink(url, type) {
            url = url || window.shareLink

            navigator.clipboard
                .writeText(url)
                .then(() => {
                    if (type != 'embed') {
                        popup.alert(this.$t('landing_alert_link_copied'), true, { icon: 'success' })
                    } else {
                        popup.alert(this.$t('embed_modal_alert_copied'), true, { icon: 'success' })
                    }
                })
                .catch(() => {
                    if (type != 'embed') {
                        popup.alert(this.$t('landing_alert_link_copied_error'), true, { icon: 'error' })
                    } else {
                        popup.alert(this.$t('embed_modal_alert_copied_error'), true, { icon: 'error' })
                    }
                })
        },

        async openEmbedModal() {
            this.removeHints()
            let getEmbedStatus = await this.getEmbed()
            if (getEmbedStatus) {
                this.showEmbedModal = true
            }
        },

        async getEmbed() {
            try {
                const request = this.createRequest()
                const url = appConfig.api.getEmbed.replace('__id__', this.id)
                const getEmbedData = await request.get(url, this.quiz)
                if (getEmbedData.status === 200) {
                    this.embed = getEmbedData.data.data
                    return true
                }

                throw 'no data'
            } catch {
                return false
            }
        },

        async toggleQuizStatus() {
            try {
                this.$store.commit('toggleMainLoader', true)

                const toggle = await this.$store.dispatch('toggleQuizStatus', this.quiz._id.$oid)

                if (toggle.status !== 200) throw toggle

                this.quizStatus = toggle.data.data.current_status
                this.$store.commit('toggleMainLoader', false)
            } catch {
                this.$store.commit('toggleMainLoader', false)
            }
        },

        trackCreateQuiz(category, label) {
            helper.gTrackEvent('create', {
                event_category: category,
                event_label: label
            })
        },

        toggleThumbnail() {
            if (this.quiz.type == 'poll' && this.quizStatus === false) return

            if (this.isCompetitions || this.isSchool) {
                this.onShowOverlay()
                return
            }

            if (!this.isPoll) {
                window.open(`${this.quiz.url}?ref=myquiz&mode=preview`)
            } else {
                window.open(`/edit/${this.id}`)
            }
        },

        getNuxtUrl(url) {
            return nuxtUrl(url)
        },

        onCopyToMyQuiz(quiz) {
            popup.confirm(this.$t('confirm_copy_to_my_quiz'), async () => {
                this.$store.commit('toggleMainLoader', true)

                const payload = {
                    id: quiz._id.$oid,
                    captcha_response: await this.getRecaptchaToken(),
                    title: quiz.title
                }

                await this.$store
                    .dispatch('copyToMyQuiz', payload)
                    .then(() => {
                        this.$store.commit('toggleMainLoader', false)
                        this.$emit('fetch-quiz')
                    })
                    .catch(err => {
                        this.$store.commit('toggleMainLoader', false)
                        if (err.response.data.message === 'reach_to_limit_in_month') {
                            popup.alert(this.$t('reach_to_limit_in_month'))
                            return
                        }

                        popup.alert(this.$t('something_went_wrong'))
                        return
                    })
            })
        },

        getRecaptchaToken() {
            return new Promise(async (resolve, reject) => {
                try {
                    const recaptcha = await load(process.env.VUE_APP_RECAPTCHA_SITE_KEY, {
                        useRecaptchaNet: true,
                        autoHideBadge: true
                    })

                    const token = await recaptcha.execute('validate_captcha', {
                        action: 'validate_captcha'
                    })

                    resolve(token)
                } catch (err) {
                    reject(err)
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.quiz-thumbnail {
    .fa-share-alt,
    .fa-share-alt-square {
        transform: rotate(180deg);
    }

    .quiz-item {
        border: 1px solid var(--ui-primary-color);
        border-color: var(--ui-primary-color);
        border-radius: 0.5rem;
        transition: border-color 0.3s;

        &.edit-mode {
            border-color: #e43146;

            .quiz-options {
                border-color: #e43146;
                background-color: #e43146;

                .quiz-option-btn-box,
                button,
                a {
                    color: #fff !important;
                }
            }
        }

        &.edit-mode:hover {
            .quiz-options {
                .quiz-option-btn-box,
                button,
                a {
                    &:hover {
                        border-color: #c32b3d !important;
                        background-color: #c32b3d !important;
                    }
                }
            }
        }

        &:not(.edit-mode):hover {
            .quiz-options {
                background-color: var(--ui-secondary-color);

                button,
                a {
                    color: var(--ui-primary-color) !important;

                    &:not(:disabled):hover {
                        color: var(--ui-secondary-color) !important;
                        background-color: var(--ui-primary-color) !important;
                    }
                }
            }
        }

        .quiz-options {
            height: 2.5rem;
            border-top: 1px solid var(--ui-primary-color);
            background-color: var(--ui-primary-color);
            transition: background-color 0.3s;
            z-index: 1;

            .quiz-option-btn-box,
            button,
            a {
                border-radius: 0;
                transition: color 0.3s, background-color 0.3s;
                color: var(--ui-secondary-color) !important;
            }
        }

        .thumbnail {
            aspect-ratio: 1 / 1;

            &:hover {
                & ~ .shadow {
                    min-height: 100%;
                }
            }

            &:not(.quiz-disabled):hover {
                @media (min-width: 992px) {
                    &::after {
                        opacity: 1;
                    }
                }
            }

            &.quiz-disabled:hover {
                @media (min-width: 992px) {
                    cursor: not-allowed !important;

                    &::after {
                        opacity: 0.6;
                    }
                }
            }

            &::after {
                font-family: 'Font Awesome 5 Free';
                font-weight: 900;
                content: '\f06e';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: var(--ui-primary-color);
                font-weight: bold;
                font-size: 2.5rem;
                text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
                opacity: 0;
                z-index: 1;
                transition: opacity 0.2s;
            }

            &.quiz-disabled {
                &::after {
                    content: '\f070';
                }
            }

            .title {
                bottom: 0;
                left: 0;
                width: 100%;
                padding: 0.5rem;
                min-height: 25%;
                display: flex;
                align-items: flex-end;
                text-align: center;
                z-index: 1;
            }

            .badge-box {
                top: 0.5rem;
                right: 0.5rem;
                display: flex;
                align-items: center;
                column-gap: 0.2rem;
            }

            .inactive-badge {
                padding: 0.25rem 0.5rem;
                border-radius: 0.5rem;
                background-color: #e43146;
                font-size: 12px;
                color: #fff;
            }

            .share-badge {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 25px;
                height: 25px;
                border-radius: 0.5rem;
                background-color: var(--ui-primary-color);
                color: var(--ui-secondary-color);
            }
        }

        .sponsor-active-box {
            background-color: var(--ui-primary-color);
            color: var(--ui-secondary-color);
            padding-top: 2px;
            z-index: 1;
        }

        .shadow {
            left: 0;
            bottom: 0;
            background-image: linear-gradient(to top, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
            width: 100%;
            padding: 0.5rem;
            min-height: calc(25% + 40px);
            display: flex;
            align-items: flex-end;
            text-align: center;
            transition: all 0.15s;
        }
    }

    .ribbon-box {
        position: absolute;
        left: 0px;
        top: 15px;
        display: inline-flex;
        width: 100%;
        pointer-events: none;
        z-index: 10;

        .ribbon {
            max-width: 70%;
            width: auto;
            height: 40px;
            background-color: #ffd700;
            display: flex;
            align-items: center;
            padding: 0 8px;
            position: relative;
            box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3);
        }

        .ribbon > div {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-decoration: none;
            color: #000;
        }

        .ribbon-tail {
            border-left: 20px solid #ffd700;
            border-right: 20px solid #ffd700;
            border-bottom: 20px solid transparent;
            transform: rotateZ(-90deg);
            position: absolute;
            right: -29px;
        }

        @media screen and (max-width: 767px) {
            .ribbon {
                height: 35px;

                .ribbon > div {
                    font-size: 14px;
                }

                .ribbon-tail {
                    border-left: 17.5px solid #ffd700;
                    border-right: 17.5px solid #ffd700;
                    border-bottom: 17.5px solid transparent;
                    right: -25.5px;
                }
            }
        }
    }

    .share-button {
        top: 0px;
        right: 7px;
        cursor: pointer;
    }

    .overlay-animation {
        will-change: opacity, transform;

        --content-gap: 1.3;
        --content-size: 1.8;

        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 999;

        .btn-close,
        .overlay-thumbnail-box,
        .big-thumbnail,
        .overlay-content {
            z-index: 10;
        }

        .btn-close {
            position: absolute;
            top: 1.25rem;
            right: 1.65rem;
            font-size: 1.5rem;
            line-height: 0;
        }

        .overlay-thumbnail-box {
            transition: all 0.3s;
            top: var(--big-thumbnail-top);
            left: var(--big-thumbnail-left);
            width: var(--big-thumbnail-w);
            // height: var(--big-thumbnail-h);
        }

        .big-thumbnail {
            border: 1px solid var(--ui-primary-color);
            border-radius: 10px;
            transition: all 0.3s;
            width: var(--big-thumbnail-w);
            height: var(--big-thumbnail-h);
            @media screen and (max-width: 768px) {
                margin: 0 auto;
            }
        }

        #simple-state {
            margin-top: 8px;
            font-size: calc(1vw + 0.525rem);
            color: var(--text-color);
            opacity: 0;
            transition: 0.3s 0.6s;
            z-index: 10;

            span {
                font-size: 0.75em;

                @media (max-width: 991px) {
                    font-size: 1rem;
                }

                @media (max-width: 575px) {
                    font-size: 0.8rem;
                }
            }
        }

        .overlay-content {
            position: absolute;
            top: 50%;
            left: calc(50% + (var(--big-thumbnail-w) / var(--content-gap)));
            transform: translate(-50%, -50%);
            width: calc(var(--big-thumbnail-w) * 1.8);
            font-size: calc(1vw + 0.525rem);
            opacity: 0;
            transition: 0.3s 0.6s;

            @media (max-width: 1366px) {
                font-size: calc(1vw + 0.75rem);
            }

            @media screen and (max-width: 768px) {
                font-size: 1.3rem;
                top: calc(15% + (var(--big-thumbnail-w)));
                left: 50%;
                transform: translateX(-50%);
                width: 100%;
            }

            @media (max-width: 575px) {
                font-size: calc(1vw + 1.5rem);
            }

            @media (max-height: 414px) {
                font-size: calc(1vw + 2.65vh);
                h2 {
                    margin-bottom: 0.5rem;
                }
            }

            @media (max-height: 375px) {
                font-size: calc(1vw + 2.65vh);
            }

            @media (max-width: 340px) {
                top: calc(15% + (var(--big-thumbnail-w)));
                font-size: calc(1vw + 2.5vh);
            }

            // .title {
            //     font-size: 1.25em;

            //     @media (max-width: 575px) {
            //         font-size: .8em;
            //     }

            //     @media (max-width: 340px) {
            //         font-size: 1em;
            //     }
            // }

            .overlay-competitions,
            .overlay-quiz-title,
            .overlay-shared-by {
                text-align: left;

                @media screen and (max-width: 768px) {
                    text-align: center;
                }
            }

            .compet-btn {
                width: fit-content;
                position: relative;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: -0.25em;
                    left: 0;
                    height: 0.1em;
                    width: 0%;
                    background-color: var(--text-color);
                    transition: 0.3s;
                }

                @media (min-width: 992px) {
                    &:hover {
                        &::after {
                            width: 100%;
                        }
                    }
                }
            }

            .menu-list {
                // font-size: .85em;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;

                // @media (max-width: 575px) {
                //     font-size: .9rem;
                // }

                // @media (max-width: 340px) {
                //     font-size: .85rem;
                // }font-size-16 md:font-size-20

                .menu-item {
                    column-gap: 1.5rem;
                    position: relative;
                    font-size: 16px;

                    @media (min-width: 768px) {
                        font-size: 20px;

                        &:hover {
                            &::after {
                                width: 100%;
                            }
                        }
                    }

                    @media screen and (max-width: 768px) {
                        margin: 0 !important;
                        padding: 0.75rem 0 0.75rem 1rem;
                        border-top: 1px solid var(--ui-primary-color);
                    }

                    @media screen and (max-width: 399px) {
                        padding: 0.6rem 0 0.6rem 1rem;
                        font-size: 14px;
                    }

                    &::after {
                        content: '';
                        position: absolute;
                        bottom: -0.25em;
                        left: 0;
                        height: 0.1em;
                        width: 0%;
                        background-color: var(--text-color);
                        transition: 0.3s;
                    }

                    > .play-report,
                    i {
                        width: 18px;
                    }
                }

                .text-shadow {
                    text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
                }
            }
        }

        &::before,
        &::after {
            content: '';
            position: fixed;
            top: var(--overlay-bg-pos-top);
            left: var(--overlay-bg-pos-left);
            width: 10vw;
            height: 10vw;
            background: rgba(0, 0, 0, 0.3);
            border-radius: 200%;
            z-index: -1;
            transition: transform cubic-bezier(0.77, 0, 0.175, 1) 0.6s, border-radius linear 0.8s;
            transform: translate(-50%, -50%) scale(0.5);
            z-index: 1;
            pointer-events: none;
            opacity: 0;
        }
        &::after {
            background-image: var(--body-bg-image);
            transition-delay: 0s;
        }
        &::before {
            transition-delay: 0.2s;
        }

        &.active {
            visibility: visible;

            &::before,
            &::after {
                transform: translate(-50%, -50%) scale(60);
                border-radius: 0;
                opacity: 0.9;
            }
            &::after {
                transition-delay: 0.1s;
            }
            &::before {
                transition-delay: 0s;
            }

            .overlay-thumbnail-box {
                transition-delay: 0.3s;
                top: 50%;
                left: calc(50% - (var(--big-thumbnail-w) / var(--content-gap)));
                transform: translate(-50%, -50%);

                &.is-competition {
                    top: var(--big-thumbnail-competition-top);
                    transform: translate(-50%, 0%);
                }

                @media (max-width: 768px) {
                    transform: translateX(-50%);
                    top: 10%;
                    left: 50%;
                    width: 100%;

                    &.is-competition {
                        top: 10%;
                    }
                }
            }

            // .big-thumbnail {
            //     transition-delay: .3s;
            //     top: 50%;
            //     left: calc(50% - (var(--big-thumbnail-w) / var(--content-gap)));
            //     transform: translate(-50%, -50%);

            //     @media (max-width: 991px) {
            //         transform: translateX(-50%);
            //         top: 10%;
            //         left: 50%;
            //     }
            // }

            #simple-state {
                opacity: 1;
            }

            .overlay-content {
                opacity: 1;
            }

            &.hide {
                .btn-close {
                    opacity: 0;
                }

                .overlay-content,
                #simple-state,
                #wiki-text {
                    opacity: 0;
                    transition-delay: 0;
                    transition: 0.3s 0s;
                }

                .overlay-thumbnail-box {
                    top: var(--big-thumbnail-top);
                    left: var(--big-thumbnail-left);
                    width: var(--big-thumbnail-w);
                    height: var(--big-thumbnail-h);
                    transform: none;
                }

                &::before,
                &::after {
                    transform: translate(-50%, -50%) scale(0.5);
                    border-radius: 200%;
                    transition-delay: 0.5s;
                }
                &::after {
                    transition-delay: 0s;
                }
                &::before {
                    transition-delay: 0.1s;
                }

                &.alreadyHide {
                    &::before,
                    &::after {
                        opacity: 0;
                    }
                    .big-thumbnail {
                        opacity: 0;
                        transition: 0.15s;
                    }
                }
            }

            #wiki-text {
                opacity: 1;
            }
        }

        #wiki-text {
            position: absolute;
            bottom: 14%;
            left: 50%;
            transform: translateX(-50%);
            padding: 0 2%;
            font-size: calc(1vw + 0.525rem);
            color: var(--text-color);
            text-align: center;
            opacity: 0;
            z-index: 10;
            transition: 0.3s 0.6s;

            @media (max-width: 575px) {
                bottom: 2%;
            }

            span {
                font-size: 0.75em;

                @media (max-width: 991px) {
                    font-size: 1rem;
                }

                @media (max-width: 575px) {
                    font-size: 0.75rem;
                }

                a {
                    color: var(--ui-primary-color);
                }
            }
        }
    }

    .blur-suspended {
        filter: blur(3px);
    }
}
</style>
